module.exports = __webpack_public_path__ + "img/salades_md.44cb5337.jpg";